import { createAction, props } from '@ngrx/store';
import { RedFlag } from '../../interfaces/red-flag';

export const loadCompanyRedFlags = createAction('[CompanyRedFlags/API] Load Company Red Flags');

export const loadCompanyRedFlagsSuccess = createAction(
  '[CompanyRedFlags/API] Load Company Red Flags Success',
  props<{ redFlags: RedFlag[] }>()
);

export const loadCompanyRedFlagsFailure = createAction(
  '[CompanyRedFlags/API] Load Company Red Flags Failure',
  props<{ error: unknown }>()
);
